"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var strategy_builder_1 = require("./strategy-builder");
var BACKOFF_INITIAL = 150;
function aWebSocketStrategyPreset1(transport) {
    return strategy_builder_1.default(transport)
        .withBackoff(BACKOFF_INITIAL)
        .build();
}
exports.aWebSocketStrategyPreset1 = aWebSocketStrategyPreset1;
function anXhrStrategyPreset1(transport) {
    return strategy_builder_1.default(transport)
        .withDelay(4000)
        .withBackoff(BACKOFF_INITIAL)
        .build();
}
exports.anXhrStrategyPreset1 = anXhrStrategyPreset1;
function anXhrStrategyPreset2(transport) {
    return strategy_builder_1.default(transport)
        .withBackoff(BACKOFF_INITIAL)
        .build();
}
exports.anXhrStrategyPreset2 = anXhrStrategyPreset2;
//# sourceMappingURL=strategy-presets.js.map